<template>
	<Col :span="24">
		<VerticalLayout>
			<Row>
				<Col :span="24" :xxl="{ span: 14 }">
					<Card :bordered="false">
						<EmailAlertsSettingsForm />
					</Card>
				</Col>
			</Row>
		</VerticalLayout>
	</Col>
</template>

<script>
import { Col, Row, Card } from 'ant-design-vue';

import VerticalLayout from '@/components/common/VerticalLayout';
import EmailAlertsSettingsForm from '@/components/settings/EmailAlertsSettingsForm';


export default {
	components: {
		Col,
		Row,
		Card,
		VerticalLayout,
		EmailAlertsSettingsForm,
	},
};
</script>
